<template>
  <div class="markbox" v-show="loading" style="background-color: rgba(0, 0, 0, 0.3);">
    <div class="loadEffect">
      <!-- <img  v-if="loading!='success' && loading!= 'error'" class="loading" src="../../assets/images/loading.png" alt="">
      <img v-if="loading=='success'" class="success" src="../../assets/images/success.png" alt="">
      <img v-if="loading=='error'" class="error" src="../../assets/images/error.png" alt=""> -->

      <div v-if="loading!='success' && loading!= 'error'" class="loading"></div>
      <div v-if="loading=='success'" class="success"></div>
      <div v-if="loading=='error'" class="error"></div>
      <span>{{content}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "loading",
  data() {
    return {
      content: "",
      loading: false,
    };
  },
  created() {
    var that = this;
    this.$bus.$on("loading", function (isShow, data) {
      console.log("loading", isShow, data);
      that.loading = isShow;
      that.content = data;
    });
  },
};
</script>

<style>
.markbox {
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  top: 0;
  z-index: 99999;
}
.loadEffect {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 300px;
  height: 300px;
  background: white;
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.loadEffect div {
  width: 110px;
  height: 110px;
  margin-bottom: 25px;
  background-size: 110px 110px !important;
  background-repeat: no-repeat !important;
}
.loadEffect .loading {
  animation: load 1s infinite linear;
}
.loadEffect .loading {
  background: url("../../assets/images/loading.png");
}
.loadEffect .success {
  background: url("../../assets/images/success.png");
}
.loadEffect .error {
  background: url("../../assets/images/error.png");
}
.loadEffect span {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 33px;
  text-align: center;
  color: #252931;
}
/* .loadEffect span {
  display: inline-block;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: white;
  position: absolute;
  -webkit-animation: load 1.04s ease infinite;
} */

@-webkit-keyframes load {
  0% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(90deg);
  }
  50% {
    transform: rotate(180deg);
  }
  75% {
    transform: rotate(270deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* .loadEffect span:nth-child(1) {
  left: 0;
  top: 50%;
  margin-top: -8px;
  -webkit-animation-delay: 0.13s;
}

.loadEffect span:nth-child(2) {
  left: 14px;
  top: 14px;
  -webkit-animation-delay: 0.26s;
}

.loadEffect span:nth-child(3) {
  left: 50%;
  top: 0;
  margin-left: -8px;
  -webkit-animation-delay: 0.39s;
}

.loadEffect span:nth-child(4) {
  top: 14px;
  right: 14px;
  -webkit-animation-delay: 0.52s;
}

.loadEffect span:nth-child(5) {
  right: 0;
  top: 50%;
  margin-top: -8px;
  -webkit-animation-delay: 0.65s;
}

.loadEffect span:nth-child(6) {
  right: 14px;
  bottom: 14px;
  -webkit-animation-delay: 0.78s;
}

.loadEffect span:nth-child(7) {
  bottom: 0;
  left: 50%;
  margin-left: -8px;
  -webkit-animation-delay: 0.91s;
}

.loadEffect span:nth-child(8) {
  bottom: 14px;
  left: 14px;
  -webkit-animation-delay: 1.04s;
} */
</style>

